// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// ExistingCourseSearchHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import CourseDTO from '../models/CourseDTO';
import CourseDetailDTO from '../models/CourseDetailDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    disciplineId: string | null | null;
    catalogNumber: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            disciplineId: null,
            catalogNumber: "",
        },
        initValues);
    },
    disciplineId: 'disciplineId',
    catalogNumber: 'catalogNumber',
}

interface Result extends ResultDTO {
    course: CourseDTO | null;
    currentCourseDetails: CourseDetailDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            course: null,
            currentCourseDetails: null,
        },
        initValues);
    },
    course: 'course',
    currentCourseDetails: 'currentCourseDetails',
}

export { Request, Result };